<template>
  <div>
    <v-layout
      align-center
      justify-center
    >
      <v-row
        align="center"
        justify="center"
      >
        <v-card
          width="100%"
          max-width="800px"
          elevation="24"
          v-show="screen.loading"
        >
          <v-container
            style="height: 400px;"
          >
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Verificando Permissão
              </v-col>
              <v-col
                cols="7"
              >
                <v-progress-linear
                  color="deep-purple accent-4"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card
          width="100%"
          max-width="800px"
          elevation="24"
          v-show="screen.error"
        >
          <v-card-text>
            <v-alert
              outlined
              color="error"
            >
              <div class="text-h6 mb-3">
                Erro na Redefinição da Senha
              </div>
              <div class="mb-3">
                Não foi possível concluir a alteração solicitada. A chave informada está expirada ou é inválida.
              </div>
              <div class="mb-3">
                Por favor, solicite a redefinição da senha novamente, para envio de nova chave.
              </div>
            </v-alert>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="default"
              @click="returnElection"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card
          width="100%"
          max-width="800px"
          elevation="24"
          v-show="screen.success"
        >
          <v-card-text>
            <v-alert
              outlined
              color="success"
            >
              <div class="text-h6 mb-2">
                A Senha foi alterada com sucesso.
              </div>
              <div class="mb-2">
                Tente fazer login na urna online com a nova senha.
              </div>
              <div class="mb-2">
                Caso não consiga, faça uma nova solicitação.
              </div>
              <div>
                Para voltar para a tela de login, clique no botão abaixo
              </div>
            </v-alert>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="default"
              @click="returnElection"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card
          width="100%"
          max-width="800px"
          elevation="24"
          v-show="screen.password"
        >
          <v-toolbar
            flat
            color="primary-color"
          >
            <v-toolbar-title>
              Redefinir senha de eleitor
            </v-toolbar-title>
            <v-spacer />
            <v-tooltip right>
              <template />
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-form
              ref="frmPRE"
            >
              <v-text-field
                v-model="tfp.one.value"
                :append-icon="tfp.one.icon"
                :type="tfp.one.type"
                label="Digite sua nova senha"
                hint="mínimo de 6 caracteres"
                @click:append="tfp.one.show = !tfp.one.show"
                :rules="[rules.required, rules.min]"
              />
              <v-text-field
                v-model="tfp.two.value"
                :append-icon="tfp.two.icon"
                :type="tfp.two.type"
                label="Confirme sua nova senha"
                @click:append="tfp.two.show = !tfp.two.show"
                :rules="[validatePassword]"
              />
            </v-form>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              :loading="btnLoading"
              :disabled="btnLoading"
              @click="btnSave"
              outlined
            >
              Salvar
            </v-btn>
            <v-btn
              color="error"
              @click="returnElection"
              :disabled="btnLoading"
              outlined
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-layout>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  data: () => ({
    btnLoading: false,
    key: '',
    tfp: {
      one: {
        value: '',
        icon: '',
        type: '',
        show: true
      },
      two: {
        value: '',
        icon: '',
        type: '',
        show: true
      },
      icons: {
        eye: 'mdi-eye',
        eyeOff: 'mdi-eye-off'
      },
      types: {
        text: 'text',
        password: 'password'
      }
    },
    rules: {
      required: value => !!value || 'Obrigatório.',
      min: v => v.length >= 6 || 'Mínimo de 6 caracteres'
    },
    screen: {
      loading: false,
      password: false,
      error: false,
      success: false
    }
  }),
  watch: {
    'tfp.one.show': function(value) {
      this.tfp.one.icon = this.tfp.icons.eyeOff;
      this.tfp.one.type = this.tfp.types.password;
      if (value) {
        this.tfp.one.icon = this.tfp.icons.eye;
        this.tfp.one.type = this.tfp.types.text;
      }
    },
    'tfp.two.show': function(value) {
      this.tfp.two.icon = this.tfp.icons.eyeOff;
      this.tfp.two.type = this.tfp.types.password;
      if (value) {
        this.tfp.two.icon = this.tfp.icons.eye;
        this.tfp.two.type = this.tfp.types.text;
      }
    },
    'screen.loading': function(value) {
      if (value) {
        this.screen.password = false;
        this.screen.error = false;
        this.screen.success = false;
      }
    },
    'screen.password': function(value) {
      if (value) {
        this.screen.loading = false;
        this.screen.error = false;
        this.screen.success = false;
      }
    },
    'screen.error': function(value) {
      if (value) {
        this.screen.password = false;
        this.screen.loading = false;
        this.screen.success = false;
      }
    },
    'screen.success': function(value) {
      if (value) {
        this.screen.password = false;
        this.screen.loading = false;
        this.screen.loading = false;
      }
    }
  },
  mounted() {
    this.tfp.one.show = false;
    this.tfp.two.show = false;
    this.key = this.$route.query.key;
    this.load();
  },
  methods: {
    ...mapActions('voter', { verifyKey: 'verifyKeyResetPassword', sendExecution: 'sendPasswordResetExecution' }),
    async load() {
      this.screen.loading = true;
      const params = { key: this.key };
      try {
        await this.verifyKey(params);
        const result = this.$store.state.voter.keyVerification;
        if (result.status === 'ok') {
          this.screen.password = true;
        } else {
          this.screen.error = true;
        }
      } catch (error) {
        this.screen.error = true;
      }
    },
    validatePassword() {
      const one = this.tfp.one;
      const two = this.tfp.two;
      let msg = '';
      if (!(one.value === two.value)) {
        msg = 'inválida!';
      }
      if (msg) {
        return msg;
      } else {
        return true;
      }
    },
    returnElection() {
      this.$router.push({ name: 'Election' });
    },
    async btnSave() {
      if (this.$refs.frmPRE.validate()) {
        const params = {};
        params.password = this.tfp.one.value;
        params.key = this.key;
        try {
          this.btnLoading = true;
          await this.sendExecution(params);
          const result = this.$store.state.voter.resultPasswordResetExecution;
          if (result.status === 'ok') {
            this.screen.success = true;
          } else {
            this.screen.error = true;
          }
        } catch (error) {
          this.screen.error = true;
        } finally {
          this.btnLoading = false;
        }
      }
    }
  }
};
</script>
